import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  title: {
    marginBottom: (props) => (props.lessMarginTop ? '10px' : '20px'),
  },
}));

export default useStyles;
